import React, { FC } from "react";
import { ActionButton, DirectionalHint, Callout as OfficeCallout } from "@fluentui/react";
import { themeUtils, useSignals, useTheme } from "cayo.ui";
import { getMenuButtonStyles } from "@cayo/shared/components/Alerts/Alerts.styles";
import { ICallout } from "../../api/schema.api";
import useCallout from "../GlobalHooks/callout.hook";
import GenericScheme from "../Schemes/GenericScheme";

type CalloutProps = ICallout & { children?: React.ReactNode };

const Callout: FC<CalloutProps> = (props) => {
  const theme = useTheme();
  const { isCalloutVisible, onShowTooltip, onDismiss } = useCallout();
  const signals = useSignals<"close">([{ s: "close", handler: onDismiss }]);
  const { children } = props;
  const padding = Array.isArray(props.padding)
    ? props.padding.map((p) => theme.cayoTheme.metrics.spacing[p]).join(" ")
    : "20px 24px";

  const id = props.id || props.name;
  return (
    <>
      <ActionButton
        id={id}
        ariaLabel={id}
        text=""
        onClick={() => (isCalloutVisible ? onDismiss() : onShowTooltip())}
        styles={getMenuButtonStyles(false, theme)}
        iconProps={themeUtils.getIconProps(props.icon)}
      />

      {isCalloutVisible && (
        <OfficeCallout
          target={`#${id}`}
          setInitialFocus={false}
          directionalHint={DirectionalHint.topCenter}
          onDismiss={onDismiss}
          gapSpace={-10}
          role="alertdialog"
          styles={{
            calloutMain: { minWidth: "250px", padding },
            root: { border: `1px solid ${theme.officeTheme.semanticColors.menuDivider}` },
          }}
        >
          {children ? (
            children
          ) : (
            // eslint-disable-next-line no-inline-styles/no-inline-styles
            <GenericScheme {...props} signals={signals} style={{ alignItems: "flex-start" }} />
          )}
        </OfficeCallout>
      )}
    </>
  );
};

export default Callout;
